import { atom } from "recoil";
import React from "react";

export const SendMessageVisibility = atom({
    key: "sendMessageVisibility", // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});
